import axios from "axios";
import { useEffect, useState } from "react";

const useAdmin = (user) => {
  const [admin, setAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userEmail = user?.email;
    if (userEmail) {
      setIsLoading(true); // Ensure loading state is updated when fetching starts
      axios
        .get(`${process.env.REACT_APP_BACKEND_API}/users/roles/${userEmail}`) //http://localhost:5000
        .then((res) => {
          setAdmin(res.data.isAdmin);
        })
        .catch((error) => {
          console.error("Error fetching admin status:", error);
          setAdmin(false); // Ensure it defaults to false if an error occurs
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [user?.email]); // Depend only on userEmail

  return [admin, isLoading];
};

export default useAdmin;
